import { AddressDetails } from "../smart-components/smart-component-property";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { GenericCounterMeasurementData } from "../generic-counter-measurements-data";
import { ElectricCounterMeasurementType } from "../../enum/enumCounterMeasurementType";
import { ComponentAdapterCounterParent } from "./component-adapter-counter-parent";

/**
 * This class handle properties of electric counter
 */
export class ComponentAdapterCounterElectric
  extends ComponentAdapterCounterParent
  implements IComponentLoader {
  private _energyAbsorbed: AddressDetails = null;
  private _energyProduced: AddressDetails = null;
  private _powerActive: AddressDetails = null;
  private _powerExchange: AddressDetails = null;
  private _activePowerMax24h: AddressDetails = null;
  private _activePowerFed: AddressDetails = null;
  private _activePowerFedMax24h: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF1: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF2: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF3: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF4: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF5: AddressDetails = null;
  private _activeEnergyImportedPreviousDayF6: AddressDetails = null;

  /**
   * Get data about heat asorbed energy
   */
  get EnergyAbsorbed(): AddressDetails {
    return this._energyAbsorbed;
  }

  /**
   * Get data about produced energy
   */
  get EnergyProduced(): AddressDetails {
    return this._energyProduced;
  }

  /**
   * Get data about active power
   */
  get ActivePower(): AddressDetails {
    return this._powerActive;
  }

  /**
   * Get data about exchange power
   */
  get ExchangePower(): AddressDetails {
    return this._powerExchange;
  }

  /**
   * Get data about active power max 24h
   */
  get ActivePowerMax24h(): AddressDetails {
    return this._activePowerMax24h;
  }

  /**
   * Get data about active power fed
   */
  get ActivePowerFed(): AddressDetails {
    return this._activePowerFed;
  }

  /**
   * Get data about active power fed max 24h
   */
  get ActivePowerFedMax24h(): AddressDetails {
    return this._activePowerFedMax24h;
  }

  /**
   * Get data about energy imported previous day F1
   */
  get EnergyImportedPreviousDayF1(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF1;
  }

  /**
   * Get data about energy imported previous day F2
   */
  get EnergyImportedPreviousDayF2(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF2;
  }

  /**
   * Get data about energy imported previous day F3
   */
  get EnergyImportedPreviousDayF3(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF3;
  }

  /**
   * Get data about energy imported previous day F4
   */
  get EnergyImportedPreviousDayF4(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF4;
  }

  /**
   * Get data about energy imported previous day F5
   */
  get EnergyImportedPreviousDayF5(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF5;
  }

  /**
   * Get data about energy imported previous day F6
   */
  get EnergyImportedPreviousDayF6(): AddressDetails {
    return this._activeEnergyImportedPreviousDayF6;
  }

  fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    data: SmartComponentSummaryData
  ): void {
    this._summary = data.summary;
    this._idSmartComponentKind = data.idSmartComponentKind;
    this._idEnvironment = data.idEnvironment;
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_ELECTRIC_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_ELECTRIC_DESCRIPTION
      )?.value || "";
    this._energyAbsorbed =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ENERGY_ABSORBED
      )?.address || null;
    this._energyProduced =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ENERGY_PRODUCED
      )?.address || null;
    this._powerActive =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_ELECTRIC_POWER_ACTIVE
      )?.address || null;
    this._powerExchange =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_POWER_EXCHANGE
      )?.address || null;
    this._activePowerMax24h =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_POWER_MAX_24H
      )?.address || null;
    this._activePowerFed =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_POWER_FED
      )?.address || null;
    this._activePowerFedMax24h =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_POWER_FED_MAX_24H
      )?.address || null;
    this._activeEnergyImportedPreviousDayF1 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F1
      )?.address || null;
    this._activeEnergyImportedPreviousDayF2 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F2
      )?.address || null;
    this._activeEnergyImportedPreviousDayF3 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F3
      )?.address || null;
    this._activeEnergyImportedPreviousDayF4 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F4
      )?.address || null;
    this._activeEnergyImportedPreviousDayF5 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F5
      )?.address || null;
    this._activeEnergyImportedPreviousDayF6 =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill ===
          SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F6
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  fillMissingProperty(): void { }

  fillAddressState(): void { }
}
